import { createContext } from 'react'

// Non-send screens remain unaffected. React context also crosses modal portals.
export default createContext(true)
